<!-- <div style="text-align: right; margin-right: 2%; margin-bottom: 1%">
  <button  style="border: none;outline:none; margin-top: 1%;" [ngClass]="{'test': activeLang == 'es'}" (click)="cambiarLenguaje('es')"
    class="text-secondary" target="blank_">{{ 'IL_LENGUAJE_ES' |
    translate }}</button>
  &nbsp;|&nbsp;
  <button style="border: none;outline: none;" [ngClass]="{'test': activeLang == 'en'}" (click)="cambiarLenguaje('en')"
    class="text-secondary" target="blank_">{{ 'IL_LENGUAJE_EN' |
    translate }}</button>
</div> -->
<div class="container-fluid bg-dark px-0" style="background-color: white !important;">
    <div class="w-100 p-4">
        <div class="row">
            <!-- Visible solo en Smartphone -->
            <div class="d-block d-lg-none">
                <div class="col-lg-12 mb-4">
                    <div class="card ">
                        <span class="d-block mb-3 text-secondary text-center font-weight-bold"
                            style="font-size: 26px; font-weight: 300">{{ 'IL_RES_STOCK_INFO' | translate }}</span>
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-lg-3"
                                    style="background-color: #484E52; color:white !important; background-repeat: no-repeat; background-size: cover; background-position: center;">
                                    <!-- Visible solo en Desktop -->
                                    <div class="row m-1" style="text-align: center !important;">
                                        <div class="col-4 col-sm-4 p-2">
                                            <h4 style="color: white !important;" class="text-secondary f-16 mb-0">
                                                {{razonSocial}}</h4>
                                        </div>
                                        <div class="col-4 col-sm-4 p-2">
                                            <h4 style="color: white !important;"
                                                class="font-weight-bold f-22 mb-0">{{(precioCierre ?
                                                precioCierre : 0) |
                                                numberFormat}} CLP</h4>
                                        </div>
                                        <div class="col-4 col-sm-4 p-2">
                                            <h4 style="color: white !important;"
                                                class="font-weight-bold f-22 mb-0"> {{(variacion ?
                                                variacion : 0) | numberFormat}}%</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-9">
                                    <div class="row m-1" style="text-align: center !important;">
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_OPENING_PRICE' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_CLOSING_PRICE_Y' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_MAX_52_W' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMax52Semanas ?
                                                preMax52Semanas : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMax52Semanas ?
                                                preMax52Semanas : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_MIN_52_W' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMin52Semanas ?
                                                preMin52Semanas : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMin52Semanas ?
                                                preMin52Semanas : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Visible solo en Desktop -->
            <div class="d-none d-lg-block w-100">
                <div class="col-lg-12">
                    <div class="card ">
                        <span class="d-block mb-3 text-secondary text-center font-weight-bold"
                            style="font-size: 26px; font-weight: 300">{{ 'IL_RES_STOCK_INFO' | translate }}</span>
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-lg-12" style="background-color: #484E52">
                                    <!-- Visible solo en Desktop -->

                                    <div class="row m-1" style="text-align: center !important;">
                                        <div class="col-4 col-sm-4 p-2">
                                            <h4 style="color:white" class=" f-16 mb-0">
                                                <strong>{{razonSocial}}</strong>
                                            </h4>
                                        </div>
                                        <div class="col-4 col-sm-4 p-2">
                                            <h4 style="color:white" class="font-weight-bold f-22 mb-0">{{(precioCierre ?
                                                precioCierre : 0) |
                                                numberFormat}} CLP</h4>
                                        </div>
                                        <div class="col-4 col-sm-4 p-2">
                                            <h4 style="color:white" class=" font-weight-bold f-22 mb-0">{{(variacion ?
                                                variacion : 0) | numberFormat}}% ({{'TYPE_CHANGE_BANNER' | translate}})</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="row m-1" style="text-align: center !important;">
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_OPENING_PRICE' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_CLOSING_PRICE_Y' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(precioAyer.pre_cie
                                                ?
                                                precioAyer.pre_cie : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_MAX_52_W' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMax52Semanas ?
                                                preMax52Semanas : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMax52Semanas ?
                                                preMax52Semanas : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                        <div class="col-6 col-sm-3 border-bottom p-2">
                                            <span class="text-muted text-uppercase">{{ 'IL_MIN_52_W' | translate
                                                }}</span>
                                            <h4 *ngIf="activeLang == 'es'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMin52Semanas ?
                                                preMin52Semanas : 0) |
                                                numberFormat}}</h4>
                                            <h4 *ngIf="activeLang == 'en'"
                                                class="text-secondary font-weight-bold f-22 mb-0">{{(preMin52Semanas ?
                                                preMin52Semanas : 0) |
                                                number: '1.2-2'}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>